import { mapState } from 'vuex';

export default {
    data: () => {
        return {
            freeDeliverySum: 5000,
        };
    },
    computed: {
        ...mapState(['total']),
        freeDeliveryLeft() {
            return this.freeDeliverySum - this.total.totalPrice;
        },
    },
};
